import { render, staticRenderFns } from "./UpDigitalBooks.vue?vue&type=template&id=13c1bcea&scoped=true&"
import script from "./UpDigitalBooks.vue?vue&type=script&lang=js&"
export * from "./UpDigitalBooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c1bcea",
  null
  
)

export default component.exports